import { createFileRoute, Outlet } from '@tanstack/react-router'
import { LegacyMatchAliasRecovery } from '~/features/football-match-detail/football-match-detail'
import { loadLegacyMatchAliasRoute } from '~/features/football-match-detail/legacy-route-options'
import { handleLegacyMatchAliasRequest } from '~/features/football-match-detail/legacy-server-handler'

export const Route = createFileRoute('/radar/events/$eventId')({
  server: {
    handlers: {
      GET: ({ request, params }) => handleLegacyMatchAliasRequest({
        request,
        sourceKind: 'polymarket_event',
        sourceId: params.eventId,
        locale: 'en',
      }),
    },
  },
  loader: ({ params, location }) => {
    const canonicalPath = `/radar/events/${encodeURIComponent(params.eventId)}`
    if (location.pathname.replace(/\/$/, '') !== canonicalPath)
      return { kind: 'nested' as const }
    return loadLegacyMatchAliasRoute({
      sourceKind: 'polymarket_event',
      sourceId: params.eventId,
      locale: 'en',
      location,
    })
  },
  component: RadarEventLegacyRoute,
  notFoundComponent: () => <LegacyMatchAliasRecovery locale="en" kind="not_found" />,
})

function RadarEventLegacyRoute() {
  const state = Route.useLoaderData()
  if (state.kind === 'nested')
    return <Outlet />
  return <LegacyMatchAliasRecovery locale="en" kind={state.kind} />
}
